import clamp from 'lodash.clamp';

/**
 * Limits a number between a min/max value
 * or returns base value
 */
export const getValueFromRangeOrBase = (value, baseValue, min, max) => {
  return (value && clamp(value, min, max)) || baseValue;
};
